import styled from "styled-components";

export const GlossaryContainer = styled.div`
display: flex;
align-items: center;
justify-content: center;   
width: 45%;               
padding: 0.75rem 1rem;
margin: 0;                
color: var(--white);
background-color: var(--chat-background);
border: 1px solid var(--white);
height: 3.125rem;
font-size: 1.125em;
font-family: "Inter";
font-weight: 400;
line-height: 1.375em;

  &:disabled {
    background-color: var(--gray);
  }
  @media (max-width: 768px) {
      width: 80%;
    }
  @media (max-width: 33.75rem) {
    font-size: 0.75em;
  }
`;
export const ButtonExpand = styled.button`
  border: 0;
  background-color: transparent;
  color: #fff;
  height: 100%;
  width: auto;
  display: flex;
  justify-content: flex-end;
`;

export const DropDownContainer = styled.div`

  width: 100%;
  margin-bottom: 0.313rem;

  .glossario-item {
    display: flex;
    align-items: center;
    justify-content: center; 
    gap: 1rem;
    
    @media(max-width: 768px){
      gap: 0.5rem;
    }
  }
  
`;

export const DropDownListContainer = styled.div`
  transition: all 0.2s linear;

  .fadeInDown {
    animation-name: fadeInDown;
    animation-duration: 0.3s;
    animation-fill-mode: both;
  }
  @-webkit-keyframes fadeInDown {
    0% {
      opacity: 0;
      transform: translate3d(0, -100%, 0);
    }
    100% {
      opacity: 1;
      transform: none;
    }
  }
  @keyframes fadeInDown {
    0% {
      opacity: 0;
      transform: translate3d(0, -100%, 0);
    }
    100% {
      opacity: 1;
      transform: none;
    }
  }

  .fadeOutUp {
    animation-name: fadeOutUp;
    animation-duration: 1s;
    animation-fill-mode: both;
  }
  @-webkit-keyframes fadeOutUp {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
      transform: translate3d(0, -100%, 0);
    }
  }
  @keyframes fadeOutUp {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
      transform: translate3d(0, -100%, 0);
    }
  }
`;

export const DropDownList = styled.ul``;

export const ButtonSeeTranslation = styled.button`
  display: flex;
  text-align: start;
  align-items: center;
  background: #ffffff;
  gap: 0.625rem;
  color: var(--blue);
  font-size: 1.125em;
  font-weight: 400;
  padding: 0.75rem;
  height: 3.125rem;
  list-style: none;
  border: none;
  width: 100%;
  text-align: start;
  :hover {
    color: #fff;
    background-color: var(--hover);
  }
  &::before {
    transition: all 0.2s ease-in-out;
    transform: scale(0, 0);
    visibility: hidden;
  }
`;
export const ButtonTrainSignal = styled.button`
  display: flex;
  text-align: start;
  align-items: center;
  background: #ffffff;
  gap: 0.625rem;
  border-radius: 0rem 0rem 0.625rem 0.625rem;
  color: var(--blue);
  font-size: 1.125em;
  font-weight: 400;
  padding: 0.75rem;
  height: 3.125rem;
  list-style: none;
  border: none;
  width: 100%;
  :hover {
    color: #fff;
    background-color: var(--hover);
    border-radius: 0rem 0rem 0.625rem 0.625rem;
    z-index: 1;
    transform: translateY(0);
    transition-delay: 0s, 0s, 0.5s;

    #icon {
      filter: invert(99%) sepia(99%) saturate(6%) hue-rotate(256deg)
        brightness(200%) contrast(100%);
    }
  }
  &::before {
    transition: all 0.2s ease-in-out;
    transform: scale(0, 0);
    visibility: hidden;
  }
`;
